<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش اطلاعات تکمیلی</v-card-subtitle>
        <v-spacer/>
        <v-card-text>


          <v-form  ref="form" lazy-validation v-model="valid">
            <v-row>
              <v-col cols="12" md="3" sm="12">
                <v-text-field
                    outlined
                    dense
                    v-model="title" label="عنوان"/>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-textarea
                    outlined
                    height="10"
                    dense
                    v-model="description" label="شرح"/>
              </v-col>

              <v-col cols="12" md="3" sm="12">
                <v-btn @click="addInfo" block depressed color="success">
                  <v-icon dense>mdi-plus</v-icon>
                  اضافه کردن
                </v-btn>
              </v-col>

            </v-row>
            <v-card-title>اطلاعات تکمیلی </v-card-title>
            <section class="style-1" style="overflow-y: auto!important;height: 30vh ">
              <b-table
                  :items="model.informationList"
                  :fields="columns"
                  stacked="md"
                  show-empty
                  responsive striped
              >
                <template #cell(actions)="row">
                  <v-btn depressed class="mr-1" x-small color="error" @click="removeInfo(row.index)">حذف</v-btn>

                </template>

              </b-table>

            </section>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" p-1 m-1"
                  @click="save"
                  :loading="loading">
                ثبت
              </v-btn>
              <v-btn
                small
                depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Unit_se from "./Unit_se";

export default {
  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      bindingErrors: [],
      valid: true,
      loading: false,
      description: '',
      title: '',
      columns:[
          {key: 'title', label: 'عنوان', },
        {key: 'description', label: 'شرح',},
        {key: 'actions', label: 'عملیات'}
      ]
    }
  },
  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },

    closed() {
      this.loading=false
      this.$router.push('/establishment')
    },
    save(){
      this.loading=true

      Unit_se.saveInfo(this.model).then(response => {
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.closed()
        }else if (response && response.response.status === 400) {
          this.loading=false
        }
      })
    },
    addInfo() {
      let info={}
      info.description=this.description
      info.title=this.title
      this.model.informationList.push(info)
      this.description=''
      this.title=''

    },
    removeInfo(index) {
      this.model.informationList.splice(index, 1)
    },


  },





}
</script>


